import './view.scss';
import './brevo.js';

const observerFadeUp = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.transitionDuration = '';
            entry.target.classList.add('fade-up--in-view');
        } else {
            entry.target.style.transitionDuration = '0s';
            entry.target.classList.remove('fade-up--in-view');

            if (entry.boundingClientRect.top < 0) {
                entry.target.classList.add('fade-up--from-top');
            } else {
                entry.target.classList.remove('fade-up--from-top');
            }

            requestAnimationFrame(() => {
                entry.target.style.transitionDuration = '';
            });
        }
    });
}, { threshold: 0.2 });

const observerFadeRotate = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('fade-rotate-target--in-view');
        } else {
            entry.target.style.transitionDelay = '0s';
            entry.target.classList.remove('fade-rotate-target--in-view');
        }
    });
}, { threshold: 0.2 });

const fadeUpElements =
    '.content .col-12 > *,' +
    '.location-slider__header, .location-slider__items, .locations .col-12, .locations__item,' +
    '.icon-list__heading, .icon-list__text, .icon-list-item, .icon-list .cta,' +
    ' .cta-banner h2, .cta-banner .cta, ' +
    '.product-slider__header, .product-slider__items, .products__header,  .products__item, ' +
    '.content-top, .content-bottom';
const fadeRotateElements = '.content-image .fg-image, .cta-banner .fg-image-container img';

document.querySelectorAll(fadeUpElements).forEach(el => {
    el.classList.add('fade-up');
    observerFadeUp.observe(el);
});

document.querySelectorAll(fadeRotateElements).forEach(el => {
    const matrix = new DOMMatrix(getComputedStyle(el).transform);
    const angleDeg = Math.round(Math.atan2(matrix.b, matrix.a) * (180 / Math.PI));
    el.style.setProperty('--fade-rotate-end', `${angleDeg}deg`);
    el.classList.add('fade-rotate-target');
    observerFadeRotate.observe(el);
});
